import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({ root: { border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#CFCFCF'}` }}));